module.exports = __webpack_public_path__ + "static/img/charm_level_84.e17c565.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/level/charm_level_84.png
// module id = g16Q
// module chunks = 0